/**
 * @enum - Run status
 */

enum RunStatus {
  'In Progress' = 0,
  Complete = 1,
  Failed = 2
}

export default RunStatus;
